import React from 'react';

export default function Section(props) {
	const { border, children, type } = props || {};
	return <div className={`section${border ? ' borderBottom' : ''}${type ? ` ${type}` : ''}`}>{children}</div>;
}
